import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar } from "@fortawesome/pro-solid-svg-icons"
import { DialogFinishScore } from "../../../../../models/Dialogs/message"
import styles from "./Rating.module.scss"
import { SizeProp } from "@fortawesome/fontawesome-svg-core"
import cn from "classnames"
import { ACTIVE_COLOR, INACTIVE_COLOR, STAR_COUNT } from "./Rating.const"

export type RatingProps = {
    score?: DialogFinishScore
    size?: SizeProp
    selectCallback?: (rating: number) => void
}

const Rating = (props: RatingProps) => {
    const { score = 0, size = "lg", selectCallback } = props
    const [hoveredRating, setHoveredRating] = useState<number | null>(null)
    const [selectedRating, setSelectedRating] = useState(Number(score))
    const isInteractive = !!selectCallback

    useEffect(() => {
        setSelectedRating(Number(score))
    }, [score])

    return (
        <div className={styles.rating}>
            {Array.from({ length: STAR_COUNT }, (_, index) => {
                const ratingValue = index + 1
                const isActive = ratingValue <= (hoveredRating ?? selectedRating)

                return (
                    <div
                        onMouseEnter={() => isInteractive && setHoveredRating(ratingValue)}
                        onMouseLeave={() => isInteractive && setHoveredRating(null)}
                        onClick={() => {
                            if (!isInteractive) return
                            const newRating = ratingValue === selectedRating ? 0 : ratingValue
                            setSelectedRating(newRating)
                            selectCallback?.(newRating)
                            setHoveredRating(null)
                        }}
                        key={index}
                    >
                        <FontAwesomeIcon
                            key={`rating-star-${ratingValue}`}
                            icon={faStar}
                            color={isActive ? ACTIVE_COLOR : INACTIVE_COLOR}
                            className={cn(
                                styles.rating__star,
                                isActive && isInteractive && styles.rating__star_active,
                                isInteractive && styles.rating__star_interactive
                            )}
                            size={size}
                        />
                    </div>
                )
            })}
        </div>
    )
}

export default React.memo(Rating)
